module.exports = __webpack_public_path__ + "media/styles/images/svg/select-white-7158d0fafc6fb0dedc9188a82f304a53.svg";